import React from 'react';
import BrandPage from './BrandPage';

const NeopowerPage = () => <BrandPage brandSlug="neopower" />;

export default NeopowerPage;
